/**
 * Formats amount in cents to whole dollar amount
 *
 * @param {number} cents
 * @param {boolean} displaySymbol - If true prepends return value with $
 * @returns {string} - Formatted amount in dollars and cents (if not 0)
 */
const formatAmount = (cents, displaySymbol = true) => {
  const currencySymbol = displaySymbol ? "$" : "";
  const amountAsStr = `${currencySymbol}${((parseInt(cents) || 0) / 100)
    .toFixed(2)
    .replace(/[.]00$/, "")}`;

  return amountAsStr.replace("$-", "-$");
};

export { formatAmount };
